import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    hideAllAccessibilityFeatures : false,
    showVoiceCommandBox : false,
    showTextReaderBox : false,
    onPageContentChange: false, // true or false doesn't matter. We are using this just to detect the chagnes.
};

const accessibilitySlice = createSlice({
    name:'accessibility',
    initialState,
    reducers : {

        setHideAllAccessibilityFeatures : (state, {payload}) => {
            state.hideAllAccessibilityFeatures = payload;
        },
        setShowVoiceCommandBox : (state, {payload}) => {
            state.showVoiceCommandBox = payload;
        },
        setShowTextReaderBox : (state, {payload}) => {
            state.showTextReaderBox = payload;
        },
        togglePageContentChange : (state) => {
            state.onPageContentChange = !state.onPageContentChange;
        },
    }
})

export const { setShowVoiceCommandBox, setShowTextReaderBox, togglePageContentChange, setHideAllAccessibilityFeatures } = accessibilitySlice.actions;

export const getHideAllAccessibilityFeatures = (state) => state.accessibility.hideAllAccessibilityFeatures;
export const getShowVoiceCommandBox = (state) => state.accessibility.showVoiceCommandBox;
export const getShowTextReaderBox = (state) => state.accessibility.showTextReaderBox;
export const getOnPageContentChange = (state) => state.accessibility.onPageContentChange;

export default accessibilitySlice.reducer;